import React, {useContext, useEffect, useState} from "react";
import "../CSS Files/tooglebar.css";
import {CreationContext} from "../../../../containers/Content/CreationSuite";
import { fabric } from 'fabric';
import {TextField} from "@material-ui/core";
import Sticker from "../Sticker";


export function LoadStickers(props) {
    const {value} = useContext(CreationContext);
    const [creationCanvas, setCreationCanvas]= value;
    const [stickers, setStickers] = useState([])
    const [searchTerm, setSearchTerm] = useState("")
    const [selectedSticker, setSelectedSticker] = useState("")
    const [page, setPage] = useState(1)


    useEffect(() => {
        setStickers(getStickers)
        fabric.Image.fromURL(selectedSticker, function (myImg) {
            creationCanvas.add(myImg);
        },{crossOrigin: 'anonymous'});
        creationCanvas.renderAll();
    }, [selectedSticker, searchTerm, page])



    const getStickers = () => {
        let offset = (page-1)*50
        if(searchTerm!==""){
            fetch('https://api.mojilala.com/v1/stickers/search?q='+searchTerm.toString()+'&rating=g&offset='+offset.toString()+'&limit=10&api_key=dc6zaTOxFJmzC')
                .then(response => response.json())
                .then(data =>{
                    const listItems = []
                    for(const [index, value] of data.data.entries()) {
                        if (value.is_animated===false)
                            listItems.push(value.images.fixed_height.url);
                        else
                            listItems.push(value.images.fixed_height.apng);
                    }
                    setStickers(listItems);
                });
        }else {
            fetch('https://api.mojilala.com/v1/stickers/trending?&rating=g&offset=' + offset.toString() + '&api_key=dc6zaTOxFJmzC')
                .then(response => response.json())
                .then(data => {
                    const listItems = []
                    //console.log(data.hits)
                    for (const [index, value] of data.data.entries()) {
                        if (value.is_animated === false)
                            listItems.push(value.images.fixed_height.url);
                        else
                            listItems.push(value.images.fixed_height.apng);
                    }
                    setStickers(listItems);
                });
        }

    }

    return (
        <div className="sidebar">
            <div className="search-outer-wrapper">
            <div className="search-wrapper">
            <label className="search-bar-label">
                    Search:
            </label>
            <TextField
                    className="search-bar"
                    id="search-text-field-sticker" />
                <button className="search-bar-button"
                    onClick={() => setSearchTerm(document.getElementById("search-text-field-sticker").value)}>
                    Search
                </button>
            </div>
            <div className="sticker-togle">
                {stickers ? stickers.map((listItems, i) =>
                <div key={i} className="sticker-toggle">
                <img name="image" src={listItems} alt={""} width="80%" height="10%" onClick={() => setSelectedSticker(listItems)}>
                </img>
                </div>) : null} 
                    </div>
                </div>
                {page > 1 ?
                    <div className="sticker-action">
                        <h4 className="inner-action-left"
                            onClick={() => setPage(page - 1)}>
                            Prev Page
                        </h4>
                        <h4 className="inner-action-right"
                            onClick={() => setPage(page + 1)}>
                            Next Page
                        </h4>
                    </div>
                    :
                    <div className="text-load-stickers" >
                <h4 className="load-text"
                    onClick={() => setPage(page + 1)}>
                    Next Page
                </h4>
            </div>
        }
        </div>


    )

}
export default Sticker;
